"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOktonCapabilities = exports.useOktonPlatform = exports.OktonPlatformProvider = void 0;
const react_1 = __importStar(require("react"));
const useOktonTheme_1 = require("../theme/useOktonTheme");
const OktonPlatformContext = (0, react_1.createContext)(undefined);
const OktonPlatformProvider = ({ system, user, businessContext, features = {}, client, children, }) => {
    const [applications, setApplications] = (0, react_1.useState)([]);
    const [favorites, setFavorites] = (0, react_1.useState)([]);
    const [navigation, setNavigation] = (0, react_1.useState)([]);
    const [preferences, setPreferences] = (0, react_1.useState)({});
    const [resolvedBusinessContext, setResolvedBusinessContext] = (0, react_1.useState)(businessContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const { theme, setTheme: setSharedTheme } = (0, useOktonTheme_1.useOktonTheme)();
    (0, react_1.useEffect)(() => {
        setResolvedBusinessContext(businessContext);
    }, [businessContext]);
    async function refreshApplications() {
        if (!client)
            return setApplications([]);
        setApplications(await client.getApplications());
    }
    async function refreshFavorites() {
        if (!client)
            return setFavorites([]);
        setFavorites(await client.getFavorites());
    }
    async function refreshNavigation() {
        if (!(client === null || client === void 0 ? void 0 : client.getNavigation))
            return setNavigation([]);
        setNavigation(await client.getNavigation(system.id));
    }
    async function refreshPreferences() {
        if (!(client === null || client === void 0 ? void 0 : client.getPreferences))
            return;
        const next = await client.getPreferences();
        setPreferences(next);
        if (next.theme === "light" || next.theme === "dark")
            setSharedTheme(next.theme);
    }
    async function addFavorite(systemId) {
        if (!client)
            return;
        await client.addFavorite(systemId);
        await refreshFavorites();
    }
    async function removeFavorite(systemId) {
        if (!client)
            return;
        await client.removeFavorite(systemId);
        await refreshFavorites();
    }
    async function setTheme(nextTheme) {
        setSharedTheme(nextTheme);
        setPreferences((current) => (Object.assign(Object.assign({}, current), { theme: nextTheme })));
        if (client === null || client === void 0 ? void 0 : client.savePreferences) {
            try {
                const saved = await client.savePreferences(Object.assign(Object.assign({}, preferences), { theme: nextTheme }));
                setPreferences(saved);
            }
            catch (_a) {
                // Keep local preference when the shared backend is temporarily unavailable.
            }
        }
    }
    (0, react_1.useEffect)(() => {
        if (!client)
            return;
        let active = true;
        setIsLoading(true);
        function safe(promise, fallback) {
            return promise.catch(() => fallback);
        }
        Promise.all([
            safe(client.getApplications(), []),
            safe(client.getFavorites(), []),
            safe(client.getNavigation
                ? client.getNavigation(system.id)
                : Promise.resolve([]), []),
            safe(client.getPreferences
                ? client.getPreferences()
                : Promise.resolve({}), {}),
            safe(client.getBusinessContext
                ? client.getBusinessContext(system.id)
                : Promise.resolve(businessContext), businessContext),
        ])
            .then((results) => {
            if (!active)
                return;
            const apps = results[0];
            const favs = results[1];
            const nav = results[2];
            const prefs = results[3];
            const context = results[4];
            setApplications(apps);
            setFavorites(favs);
            setNavigation(nav);
            setPreferences(prefs);
            if (prefs.theme === "light" || prefs.theme === "dark")
                setSharedTheme(prefs.theme);
            if (context)
                setResolvedBusinessContext(context);
            setIsLoading(false);
        })
            .catch(() => {
            if (active)
                setIsLoading(false);
        });
        return () => {
            active = false;
        };
    }, [client, system.id]);
    const value = (0, react_1.useMemo)(() => ({
        system,
        user,
        businessContext: resolvedBusinessContext,
        features,
        applications,
        favorites,
        navigation,
        preferences,
        theme,
        isLoading,
        refreshApplications,
        refreshFavorites,
        refreshNavigation,
        refreshPreferences,
        addFavorite,
        removeFavorite,
        setTheme,
        client,
    }), [
        system,
        user,
        resolvedBusinessContext,
        features,
        applications,
        favorites,
        navigation,
        preferences,
        theme,
        isLoading,
        client,
    ]);
    return (react_1.default.createElement(OktonPlatformContext.Provider, { value: value }, children));
};
exports.OktonPlatformProvider = OktonPlatformProvider;
function useOktonPlatform() {
    const context = (0, react_1.useContext)(OktonPlatformContext);
    if (!context)
        throw new Error("useOktonPlatform deve ser usado dentro de OktonPlatformProvider.");
    return context;
}
exports.useOktonPlatform = useOktonPlatform;
function useOktonCapabilities() {
    const { features } = useOktonPlatform();
    return {
        features,
        can: (capability) => features[capability] === true,
    };
}
exports.useOktonCapabilities = useOktonCapabilities;
//# sourceMappingURL=OktonPlatformProvider.js.map